import TopSection from "../../LT/TopSection";

const ForecastCollabCPS = () => {
    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "CPS Forecast" },
                ]}
                tabTitle="CPS Forecast"
            />
        </div>
    )
}

export default ForecastCollabCPS;